"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = void 0;
// THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
exports.space = {
    "scale": [
        "0rem",
        "0.25rem",
        "0.5rem",
        "0.75rem",
        "1rem",
        "1.5rem",
        "2rem",
        "3rem",
        "4rem",
        "6rem",
        "8rem",
        "12rem",
        "24rem"
    ],
    "map": {
        "0x": "0rem",
        "quarter-x": "0.25rem",
        "half-x": "0.5rem",
        "three-quarter-x": "0.75rem",
        "1x": "1rem",
        "one-and-a-half-x": "1.5rem",
        "2x": "2rem",
        "3x": "3rem",
        "4x": "4rem",
        "6x": "6rem",
        "8x": "8rem",
        "12x": "12rem",
        "24x": "24rem"
    }
};
//# sourceMappingURL=space.js.map